import { render, staticRenderFns } from "./PaymentsListView.vue?vue&type=template&id=394d1f1d&"
import script from "./PaymentsListView.vue?vue&type=script&lang=js&"
export * from "./PaymentsListView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports